
import { stringReplaceCharAtIndex } from "@/utils/strings";
import Vue from "vue";
export default Vue.extend({
	props: {
		value: String,
		fancy: Boolean,
		label: String,
		hasError: Boolean
	},
	methods: {
		onFocus(event:FocusEvent) {
			let target = event.target as HTMLInputElement;
			if (target){
				target.setSelectionRange(0,0);
			}
			this.$emit("focus", event);
		},
		onSelectionChange(event:Event){
			let target = event.target as HTMLInputElement;
			if (!target) return;
			let value = this.value.replace(/\.*$/, "");
			if (target.selectionStart == null) return;
			if (target.selectionStart > value.length){
				target.setSelectionRange(value.length, value.length);
			}
		},
		onBlur(event:FocusEvent){
			this.$emit("blur", event);
		},
		onKeyDown(event:KeyboardEvent) {
			if (event.altKey) return;
			if (event.ctrlKey) return;
			if (this.isKeyAllowed(event.key)) {
				return;
			}
			let target = event.target as HTMLInputElement;
			if (!target) return;

			event.preventDefault();
			if (event.key == "Backspace") {
				this.onBackspace(target, event);
			}
			if (event.key == "Delete") {
				this.onDelete(target, event);
			}

			if (!event.key.match(/^[0-9\.]$/)) {
				return;
			}

			if (this.value.length > 6) {
				return;
			}

			let index = target.selectionStart || 0;
			if (index > 5) {
				return;
			}

			if (event.key == ".") {
				this.onDot(target, event);
			}else{
				this.onNumber(target, event, event.key);
			}
		},
		getIndexOfLastNum(value:string):number {
			let indexOfLastNum = -1;
			for (let i = 0; i < 6; i++) {
				if (/[0-9]/.test(this.value.charAt(i))) {
					indexOfLastNum = i;
				}
			}
			return indexOfLastNum;
		},
		isKeyAllowed(key:string) {
			if (key.startsWith("Arrow")) {
				return true;
			}
			if (key == "Home") {
				return true;
			}
			if (key == "End") {
				return true;
			}
			if (key == "Tab") {
				return true;
			}
			return false;
		},
		onBackspace(elem:HTMLInputElement, event:KeyboardEvent) {
			let index = elem.selectionStart || 0;
			index = index-1;
			if (index < 0 || index > 5) {
				return;
			}
			let indexOfLastNum = this.getIndexOfLastNum(this.value);
			if (indexOfLastNum > index) {
				return;
			}
			let value = stringReplaceCharAtIndex(this.value, index, ".");
			this.onNewValueComputed(elem, value, index-1);
		},
		onDelete(elem:HTMLInputElement, event:KeyboardEvent) {
			let index = elem.selectionStart || 0;
			if (index < 0 || index > 5) {
				return;
			}
			let indexOfLastNum = this.getIndexOfLastNum(this.value);
			if (indexOfLastNum > index) {
				return;
			}
			let value = stringReplaceCharAtIndex(this.value, index, ".");
			this.onNewValueComputed(elem, value, index-1);
		},
		onNumber(elem:HTMLInputElement, event:KeyboardEvent, num:string) {
			let index = elem.selectionStart || 0;
			let firstIndex = this.value.indexOf(".");
			if (firstIndex > 0 && firstIndex < index) {
				return;
			}
			let value = stringReplaceCharAtIndex(this.value, index, event.key);
			this.onNewValueComputed(elem, value, index);
		},
		onDot(elem:HTMLInputElement, event:KeyboardEvent) {
			let index = elem.selectionStart || 0;
			let value = this.value.substring(0, index) + ".".repeat(6-index);
			this.onNewValueComputed(elem, value, index-1);
		},
		onNewValueComputed(elem:HTMLInputElement, val:string, index:number) {
			this.$emit("input", val);
			requestAnimationFrame(()=>{
				elem.setSelectionRange(index+1, index+1);
			});
		},
		onInput(event:Event) {
			(event.target as HTMLInputElement).value = this.value;
		}
	},
	mounted(){
		if (this.value.length == 0) {
			this.$emit("input", "......");
		}else if (this.value.length > 6) {
			this.$emit("input", this.value.substring(0, 6));
		}else if (this.value.length < 6) {
			this.$emit("input", this.value + ".".repeat(6 - this.value.length));
		}
	}
});
